"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Defaults = {
    baseUrl: 'https://api.particle.io',
    clientSecret: 'particle-api',
    clientId: 'particle-api',
    tokenDuration: 7776000,
    auth: undefined
};
exports.default = Defaults;
module.exports = Defaults;
//# sourceMappingURL=Defaults.js.map